import Repository from "./masterRepository";

// sms templates
const getSms = "getSmsTemplates";

//email templates
const getEmail = "getEmailTemplates";

export default {
    getSmsTemplates(payload) {
        return Repository.post(transformRoute(getSms), payload);
  },
  
  getEmailTemplates(payload) {
        return Repository.post(transformRoute1(getEmail), payload);
  },
}

const transformRoute = (route) => {
  return `/templates/sms/${route}`;
};

const transformRoute1 = (route) => {
  return `/templates/email/${route}`;
};